import { resourceTypesGenerator } from '../../utils';

const DOCUMENTS_REMOVE_FROM_CACHE = 'app/documents/REMOVE_FROM_CACHE';

export default {
  ...resourceTypesGenerator('documents'),
  DOCUMENTS_REMOVE_FROM_CACHE,
};
